<template>
  <div class="big mydialog">
    <div class="page_title flex_between">
      <span>设置医生</span>
      <el-button
        type="primary"
        size="medium"
        style="width: 92px"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <el-button
            type="primary"
            icon="el-icon-plus"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('561') : false
            "
            @click="adddialog"
          >添加医生</el-button>
        </div>
        <div
          class="flex between"
          style="margin-bottom: 12px"
        >
          <span>
            <span style="font-size: 18px">已设置{{ allDoctor }}人</span>
            <span style="margin: 0 10px 0 20px">
              <span>医生姓名</span>
              <el-input
                v-model="list_doctor_name"
                style="width: 150px; margin-left: 5px"
                @input="searchList"
                clearable=""
              ></el-input>
            </span>

            <el-button
              type="info"
              size="medium"
              @click="searchList"
            >查询</el-button>
          </span>
          <span>
            <el-button
              type="primary"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('552') : false
              "
              @click="removeDoctor"
            >移除医生</el-button>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection"></el-table-column>

            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            ></el-table-column>
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
                <span v-if="scope.row.sex == 0">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="age"
              label="年龄"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="职称"
            ></el-table-column>
            <el-table-column
              prop="department_name"
              label="科室"
            ></el-table-column>
            <el-table-column
              prop="hospital"
              label="医院"
            ></el-table-column>
            <el-table-column
              prop="address"
              label="地区"
            ></el-table-column>
            <el-table-column
              prop="recommender_name"
              label="推荐人姓名"
            ></el-table-column>
            <el-table-column
              prop="recommender_phone"
              label="推荐人手机号"
            ></el-table-column>
            <el-table-column
              prop="recommender_code"
              label="邀请码"
            ></el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="添加医生"
      :visible.sync="adddoctor"
      width="870px"
      :close-on-click-modal="false"
      :before-close="closeDia"
    >
      <div>
        <div class="searchbox">
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="doctor_name"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">性别</span>
            <el-select
              v-model="sex"
              placeholder="请选择"
              style="width: 120px"
              @change="search"
            >
              <el-option
                label="全部"
                :value="0"
              />
              <el-option
                label="男"
                :value="1"
              />
              <el-option
                label="女"
                :value="2"
              />
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">医生手机</span>
            <el-input
              v-model="phone"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">职称</span>
            <el-select
              v-model="title"
              placeholder="请选择职称"
              style="width: 120px"
              @change="search"
            >
              <el-option
                v-for="(item, index) in [
                  '主任医师',
                  '副主任医师',
                  '主治医师',
                  '住院医师'
                ]"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">科室</span>
            <el-input
              v-model="department_name"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医院</span>
            <el-input
              v-model="hospital"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">所在地区</span>
            <el-cascader
              v-model="district"
              :options="goodsTypeData"
              placeholder="请选择"
              :props="goodsTypeSet"
              style="width: 330px"
              @change="search"
            ></el-cascader>
          </div>
          <div class="item">
            <span class="itemtitle">推荐人</span>
            <el-input
              v-model="recommender_name"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">推荐人手机</span>
            <el-input
              v-model="recommender_phone"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">邀请码</span>
            <el-input
              v-model="recommender_code"
              size="medium"
              style="width: 120px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <el-button
              type="primary"
              @click="search"
              size="medium"
            >查询</el-button>
            <el-button
              plain
              @click="reSet"
              size="medium"
            >重置</el-button>
          </div>
        </div>
        <div style="padding: 0 10px">
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="doctorData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                label="医生信息"
                width="130"
              >
                <template slot-scope="scope">
                  <div>
                    <span style="margin-right: 4px">{{
                      scope.row.doctor_name
                    }}</span>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span v-if="scope.row.sex == 0">未知</span>
                    <span style="margin-left: 4px">{{ scope.row.age }}岁</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="职称"
              ></el-table-column>
              <el-table-column
                prop="department_name"
                label="科室"
              ></el-table-column>
              <el-table-column
                prop="hospital"
                label="医院"
              ></el-table-column>
              <el-table-column
                prop="address"
                label="地区"
              ></el-table-column>
              <el-table-column
                prop="recommender_name"
                label="推荐人姓名"
              ></el-table-column>
              <el-table-column
                prop="recommender_phone"
                label="推荐人手机"
                width="110"
              ></el-table-column>
              <el-table-column
                prop="recommender_code"
                label="邀请码"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <el-pagination
            @size-change="doctorSizeChange"
            @current-change="doctorCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 10px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
      <div style="padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="setDoctor"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('562') : false
            "
          >添加，并继续查询</el-button>
          <el-button
            plain
            @click="closeDia"
            size="medium"
          >取消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import _ from 'lodash';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      allDoctor: 0,
      tableData: [],
      list_doctor_name: '',
      doctorData: [],
      adddoctor: false,
      drug_type: '',
      selection: '',
      doctor_name: '',
      sex: 0,
      phone: '',
      title: '',
      department_name: '',
      hospital: '',
      recommender_name: '',
      recommender_phone: '',
      recommender_code: '',
      district: [],
      goodsTypeData: [],
      goodsTypeSet: {
        value: 'value',
        label: 'label',
        children: 'children',
        checkStrictly: true
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取医生
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.list_doctor_name
      };
      this.axios
        .post('platform/TraditionOintment/getTraditionOintmentDoctorList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
            this.allDoctor = res.data.total;
          }
        });
    },
    //已设置列表搜索
    searchList() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //多选
    handleSelectionChange(val) {
      let selection = [];
      selection = val.map((item) => {
        return item.doctor_id;
      });
      this.selection = selection.toString();
    },
    //获取地区信息
    getCityData() {
      platform.getProvinceCityDistrict().then((res) => {
        if (res.code == 0) {
          let tree = res.data.list;
          this.transRegions(tree);
          this.goodsTypeData = tree;
        }
      });
    },
    transRegions(tree) {
      tree.forEach((item) => {
        if (item.city || item.district) {
          item.children = item.city || item.district;
          delete item.city;
          delete item.district;
          this.transRegions(item.children);
        }
        if (item.province_id) {
          item.value = item.province_id;
          delete item.province_id;
        }
        if (item.city_id) {
          item.value = item.city_id;
          delete item.city_id;
        }
        if (item.district_id) {
          item.value = item.district_id;
          delete item.district_id;
        }
        if (item.name) {
          item.label = item.name;
          delete item.name;
        }
      });
    },
    //设置医生弹窗
    adddialog() {
      this.reSet();
      this.currentPage = 1;
      this.pagesize = 10;
      this.totalNum = 0;
      this.adddoctor = true;
      this.getDoctorList();
    },
    //查询医生
    getDoctorList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        sex: this.sex,
        phone: this.phone,
        title: this.title,
        department_name: this.department_name,
        hospital: this.hospital,
        recommender_name: this.recommender_name,
        recommender_phone: this.recommender_phone,
        recommender_code: this.recommender_code,
        province_id: this.district[0],
        city_id: this.district[1],
        district_id: this.district[2]
      };
      this.axios
        .post('platform/TraditionOintment/getDoctorList', data)
        .then((res) => {
          if (res.code == 0) {
            this.doctorData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getDoctorList();
    },
    //选择医生每页数据的条数
    doctorSizeChange(size) {
      this.pagesize = size;
      this.getDoctorList();
    },
    //选择医生当前第几页
    doctorCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getDoctorList();
    },
    //重置搜索
    reSet() {
      this.doctor_name = '';
      this.sex = 0;
      this.phone = '';
      this.title = '';
      this.department_name = '';
      this.hospital = '';
      this.recommender_name = '';
      this.recommender_phone = '';
      this.recommender_code = '';
      this.district = [];
      this.getDoctorList();
    },
    //设置医生
    setDoctor() {
      if (!this.selection) {
        this.$message.error('请先选择添加的医生');
        return false;
      }
      let data = {
        doctor_type: 2,
        doctor_id: this.selection
      };
      this.axios
        .post(
          'platform/TraditionOintment/saveTraditionOintmentDoctorInfo',
          data
        )
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.selection = '';
            this.getDoctorList();
          }
        });
    },
    //关闭弹窗
    closeDia() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.selection = '';
      this.adddoctor = false;
      this.getList();
    },
    //保存之前的设置
    saveDoctor() {
      let loading = this.$loading();
      let drug_data = {
        page: 1,
        pageNumber: 10000
      };
      this.axios
        .post(
          'platform/TraditionOintment/getTraditionOintmentDoctorList',
          drug_data
        )
        .then((res) => {
          if (res.code == 0) {
            let idArr = res.data.list.map((item) => {
              return item.doctor_id;
            });
            let data = {
              doctor_type: 2,
              doctor_id: idArr.toString()
            };
            this.axios
              .post(
                'platform/TraditionOintment/saveTraditionOintmentDoctorInfo',
                data
              )
              .then((res) => {
                if (res.code == 0) {
                  loading.close();
                  this.$message.success('保存成功');
                  this.back();
                }
              });
          }
        });
    },
    //移除医生
    removeDoctor() {
      if (!this.selection) {
        this.$message.error('请先选择需要移除的医生');
        return false;
      }
      let data = {
        doctor_id: this.selection
      };
      this.axios
        .post(
          'platform/TraditionOintment/removeTraditionOintmentDoctorInfo',
          data
        )
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('移除成功');
            this.selection = '';
            this.getList();
          }
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.drug_type = this.$route.query.drug_type;
    this.getList();
    this.getCityData();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 5px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      width: 80px;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.mydialog .el-dialog__body {
  padding: 0px !important;
}
</style>